import { fullName } from '../../../../app/common/helpers/users';
var isBarberWithUsers = function (barber) {
    var _a;
    return !!((_a = barber.users) === null || _a === void 0 ? void 0 : _a.length);
};
var getListEntryForBarber = function (barber) {
    var user = barber.users[0];
    return {
        name: fullName(barber),
        userId: user.id,
        username: user.username,
        userType: 'barber',
    };
};
export var mapBarbersToUserListEntries = function (barbers) {
    return barbers.filter(isBarberWithUsers).map(function (barber) { return getListEntryForBarber(barber); });
};
export var mapShopUsersToUserListEntries = function (users, shop) {
    return users.map(function (user) {
        var entry = {
            name: shop.name,
            userId: user.id,
            username: user.username,
            userType: 'shop',
        };
        if (user.brand) {
            entry.userType = 'brand';
        }
        return entry;
    });
};
